import { IOrder, IUserProfile, IUserPromocode } from '@/interfaces';
import { MainState, AppNotification } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setToken(state: MainState, payload: string) {
        state.token = payload;
    },
    setLoggedIn(state: MainState, payload: boolean) {
        state.isLoggedIn = payload;
    },
    setLogInError(state: MainState, payload: boolean) {
        state.logInError = payload;
    },
    setUserProfile(state: MainState, payload: IUserProfile) {
        state.userProfile = payload;
    },
    setUserPromocodes(state: MainState, payload: IUserPromocode[]) {
        state.userPromocodesList = payload
    },
    setDashboardMiniDrawer(state: MainState, payload: boolean) {
        state.dashboardMiniDrawer = payload;
    },
    setDashboardShowDrawer(state: MainState, payload: boolean) {
        state.dashboardShowDrawer = payload;
    },
    setOutsideHeaderMobileMenuOpen(state: MainState, payload: boolean) {
        state.outsideHeaderMobileMenuOpen = payload;
    },
    addNotification(state: MainState, payload: AppNotification) {
        state.notifications.push(payload);
    },
    removeNotification(state: MainState, payload: AppNotification) {
        state.notifications = state.notifications.filter((notification) => notification !== payload);
    },
    setOrdersList(state: MainState, payload: IOrder[]) {
        state.ordersList = payload;
    },
    setAppConfigs(state: MainState, payload: any) {
        state.appConfigs = payload;
    },
};

const {commit} = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardMiniDrawer = commit(mutations.setDashboardMiniDrawer);
export const commitSetDashboardShowDrawer = commit(mutations.setDashboardShowDrawer);
export const commitSetOutsideHeaderMobileMenuOpen = commit(mutations.setOutsideHeaderMobileMenuOpen);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetUserProfile = commit(mutations.setUserProfile);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
export const commitSetOrdersList = commit(mutations.setOrdersList);
export const commitSetAppConfigs = commit(mutations.setAppConfigs);
export const commitSetUserPromocode = commit(mutations.setUserPromocodes);
